export enum FeatureDonationsInputNames {
  DonationsEnabled = 'donationsEnabled',
  DonationsValues = 'donationsValues',
}
